<template>
  <v-data-table :items="items" :loading="loading" hide-actions>
    <template v-slot:headers>
      <tr class="headerRow grey lighten-3">
        <th v-if="readOnly">クリエイティブ名</th>
        <td v-else class="creative-header">
          <v-checkbox
            @click.stop="onClickAll"
            v-model="isAllCheck"
            :disabled="disableAllCheck"
            label="クリエイティブ名"
            class="creative-name-checkbox"
            color="gray"
          />
          <v-btn @click="copy" :disabled="disabledCopy" small>
            コピー
          </v-btn>
          <v-btn
            @click="$emit('paste')"
            :disabled="disablePaste"
            style="margin-left: 70px"
            small
          >
            ペースト
          </v-btn>
        </td>
        <th>ステータス</th>
      </tr>
    </template>
    <template v-slot:items="{ item }">
      <tr
        @click="$emit('input', item)"
        :class="{ 'blue lighten-2 white--text': isSelected(item) }"
        class="itemRow"
      >
        <td class="text-no-wrap align-center align-content-center">
          <v-checkbox
            @click.stop="onClick(item)"
            :input-value="isCheckedItem(item.id)"
            v-if="!readOnly"
            class="creative-name-checkbox"
            color="gray"
          />
          <AppWarning :warningMessages="warningMessages(item)" />
          <span class="creative-name">{{ item.name }}</span>
        </td>
        <td>
          <AppStatus
            v-if="item.status"
            :value="item.status"
            :readonly="true"
            with-icon
          />
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <td colspan="2">
        <div class="text-xs-center">
          <slot name="empty">クリエイティブが設定されていません</slot>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { css } from 'emotion'
import xor from 'lodash/xor'
import CreativeValidation from '@/models/CampaignOperation/Form/CreativeValidation'
export default {
  name: 'CampaignModalPageCreativeCreativeTable',
  props: {
    value: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disablePaste: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAllCheck: false,
      checkedIds: [],
      visibleEditCreativesModel: false,
    }
  },
  computed: {
    headers() {
      return ['クリエイティブ名', 'ステータス'].map(text => ({
        text,
        sortable: false,
      }))
    },
    disabledCopy() {
      return this.checkedIds.length === 0
    },
    disableAllCheck() {
      return this.items.length === 0
    },
  },
  watch: {
    items() {
      this.checkedIds = []
      this.isAllCheck = false
    },
  },
  methods: {
    onClickAll() {
      this.isAllCheck = !this.isAllCheck
      this.checkedIds = this.isAllCheck ? this.items.map(item => item.id) : []
    },
    onClick(item) {
      this.checkedIds = xor(this.checkedIds, [item.id])
    },
    isCheckedItem(id) {
      return this.checkedIds.includes(id)
    },
    isSelected(item) {
      return this.value && this.value.id === item.id
    },
    icon(item) {
      if (item.hasWarning) {
        return 'warning'
      } else if (item.hasNotice) {
        return 'information'
      } else {
        return ''
      }
    },
    iconStyles(item) {
      return [
        css`
          width: 30px;
        `,
        {
          'yellow--text text--darken-2': item.hasWarning,
          'info--text text--lighten-1': !item.hasWarning && item.hasNotice,
        },
      ]
    },
    warningMessages(creative) {
      const message = CreativeValidation.getWarningMessage(creative)
      return message ? [message] : []
    },
    copy() {
      const creatives = this.items.filter(v => this.checkedIds.includes(v.id))
      this.$emit('copy', creatives)
    },
  },
}
</script>

<style scoped lang="scss">
.itemRow {
  cursor: pointer;

  td {
    padding: 0 8px !important;
  }
}
.creative-name-checkbox {
  display: inline-block;
  padding: 0 !important;
}
.headerRow {
  height: 33px;
  td {
    padding: 0 !important;
    margin: 0 !important;
  }
}
.creative-header {
  height: 24px;
  .creative-name-checkbox {
    padding: 4px 0 0 8px !important;
  }
  .v-btn--small {
    position: absolute;
    height: 22px;
    min-width: 50px !important;
    font-size: 8px;
  }
}
.creative-name {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
